import { fetchApi } from 'Utils/utils';

const URL_PREFIX = '/api/v1/reports/dormantCustomers';

const get = function(params) {
  return fetchApi.post(`${URL_PREFIX}/get/`, params);
};

export { get };
